import React, { useCallback, useMemo } from 'react'
import { ProgressOverviewPageConfig } from '../../../../../../../../../domain/entity/version-report/VersionReportTemplateEntity'
import { PageValidationError } from '../../../../../../../../../domain/entity/version-report/VersionReportTemplateEntity/validator'
import { ProjectPlanTemplateSelect } from '../../../../ProjectPlanSelect'
import { usePageConfigHandlers } from '../hooks/usePageConfigHandlers'
import {
  ConfigContainer,
  SectionContent,
  FormSection,
  FormLabel,
  PageTitleInput,
  ProjectPlanSelectWrapper,
  ErrorBanner,
  ErrorMessages,
  ErrorMessage,
} from '../styles'
import { VersionReportTemplatePageFormModel } from '../../../model/VersionReportTemplatePageFormModel'

type ConfigFormProps = {
  page: VersionReportTemplatePageFormModel
  projectUuid: string
  validationErrors?: PageValidationError[]
  onUpdate: (
    pageNumber: number,
    updater: (
      prev: VersionReportTemplatePageFormModel
    ) => VersionReportTemplatePageFormModel
  ) => void
}

export const ProgressOverviewConfigForm: React.FC<ConfigFormProps> = ({
  page,
  projectUuid,
  validationErrors,
  onUpdate,
}) => {
  const config = useMemo(
    () => page.config as ProgressOverviewPageConfig,
    [page.config]
  )

  const { handlePageTitleChange } = usePageConfigHandlers(page, onUpdate)

  const handleUuidSelect = useCallback(
    (uuid: string, selected: boolean) => {
      onUpdate(page.pageNumber, prevEntity => {
        const currentConfig = prevEntity.config as ProgressOverviewPageConfig
        const currentUuids = currentConfig.targetUuids || []

        const updatedUuids = selected
          ? currentUuids.includes(uuid)
            ? currentUuids
            : [...currentUuids, uuid]
          : currentUuids.filter(u => u !== uuid)

        return {
          ...prevEntity,
          config: {
            ...currentConfig,
            targetUuids: updatedUuids,
          },
        }
      })
    },
    [onUpdate, page.pageNumber]
  )

  return (
    <ConfigContainer>
      {validationErrors && validationErrors.length > 0 && (
        <ErrorBanner>
          <ErrorMessages>
            {validationErrors.map((error, index) => (
              <ErrorMessage key={index}>• {error.message}</ErrorMessage>
            ))}
          </ErrorMessages>
        </ErrorBanner>
      )}
      <SectionContent>
        <FormSection>
          <PageTitleInput
            label="ページタイトル"
            value={page.pageTitle}
            onChange={handlePageTitleChange}
            placeholder="ページのタイトルを入力してください"
            variant="outlined"
            required={true}
          />
        </FormSection>
        <FormSection>
          <FormLabel>対象工程を選択してください</FormLabel>
          <ProjectPlanSelectWrapper>
            <ProjectPlanTemplateSelect
              key={page.pageNumber}
              projectUuid={projectUuid}
              selectedUuids={config.targetUuids || []}
              updateSelectedUuid={handleUuidSelect}
            />
          </ProjectPlanSelectWrapper>
        </FormSection>
      </SectionContent>
    </ConfigContainer>
  )
}
